export const findSelectValueFromRowLabel = (
   rowLabel: any,
   options?: Array<{ value: string; label: string }>,
) => {
   const label = rowLabel === null ? "" : String(rowLabel);

   if (!label) return { value: "", label: "" };

   const findOption = (options ?? []).find((option) => String(option.label) === label);

   if (findOption) return { value: findOption.value, label: findOption.label };

   return { value: "", label };
};
